export const DEFAULT_CLASSES = [
  { name: "A", min: 250000, pref: 10, perk: "" },
  { name: "B", min: 100000, pref: 9, perk: "" },
  { name: "C", min: 25000, pref: 8, perk: "" },
];

export const sortClasses = (cls) => (Array.isArray(cls) ? cls : []).filter((c) => c && +c.min > 0).map((c) => ({ ...c, min: +c.min, pref: +c.pref || 0 })).sort((a, b) => b.min - a.min);

export const classFor = (cls, amount) => sortClasses(cls).find((c) => amount >= c.min) || null;

export const minOfClasses = (cls) => { const s = sortClasses(cls); return s.length ? s[s.length - 1].min : 0; };

export const classRange = (cls, c) => {
  const s = sortClasses(cls); const i = s.findIndex((x) => x.name === c.name && x.min === c.min);
  return i <= 0 ? `${fmtK(c.min)}+` : `${fmtK(c.min)} – ${fmtK(s[i - 1].min - 1)}`;
};

export const fmtK = (n) => (n >= 1000000 ? `$${(n / 1000000).toFixed(n % 1000000 ? 2 : 0)}M` : n >= 1000 ? `$${Math.floor(n / 1000)}k` : `$${Math.round(n).toLocaleString()}`);
